export const deviceCategories = [
  {
    category: 'Phone',
    makes: [
      {
        name: 'iPhone',
        models: [
          'iPhone 14 Pro Max', 'iPhone 14 Pro', 'iPhone 14 Plus', 'iPhone 14',
          'iPhone 13 Pro Max', 'iPhone 13 Pro', 'iPhone 13',
          'iPhone 12 Pro Max', 'iPhone 12 Pro', 'iPhone 12',
          'iPhone 11 Pro Max', 'iPhone 11 Pro', 'iPhone 11',
          'iPhone XS Max', 'iPhone XS', 'iPhone XR', 'iPhone X',
          'iPhone 8 Plus', 'iPhone 8', 'iPhone 7 Plus', 'iPhone 7'
        ]
      },
      {
        name: 'Samsung',
        models: [
          'Galaxy S24 Ultra', 'Galaxy S24+', 'Galaxy S24',
          'Galaxy S23 Ultra', 'Galaxy S23+', 'Galaxy S23',
          'Galaxy S22 Ultra', 'Galaxy S22+', 'Galaxy S22',
          'Galaxy S21 Ultra', 'Galaxy S21+', 'Galaxy S21',
          'Galaxy S20 Ultra', 'Galaxy S20+', 'Galaxy S20',
          'Galaxy Note 20 Ultra', 'Galaxy Note 20',
          'Galaxy A54', 'Galaxy A53', 'Galaxy A52', 'Galaxy A51'
        ]
      }
    ]
  },
  {
    category: 'Computer Repair',
    makes: [
      {
        name: 'Service Type',
        models: [
          'Virus & Malware Removal', 'Data Recovery', 'Hardware Repair',
          'Software Installation', 'OS Installation', 'System Upgrade',
          'Network Setup', 'Printer Setup', 'General Troubleshooting'
        ]
      }
    ]
  },
  {
    category: 'Network Setup',
    makes: [
      {
        name: 'Service Type',
        models: [
          'WiFi Installation', 'Router Configuration', 'Network Security Setup',
          'Network Troubleshooting', 'Network Expansion', 'Business Network Setup'
        ]
      }
    ]
  },
  {
    category: 'Security Installation',
    makes: [
      {
        name: 'Service Type',
        models: [
          'Camera Installation', 'Security System Setup', 'Access Control Installation',
          'Video Doorbell Installation', 'Security System Maintenance'
        ]
      }
    ]
  },
  {
    category: 'TV Mounting',
    makes: [
      {
        name: 'TV Size',
        models: [
          'Under 32"', '32" - 43"', '44" - 55"',
          '56" - 65"', '66" - 75"', '76" and above'
        ]
      }
    ]
  }
];